export function getFontWeight(transformer) {
    return Object.freeze({
        normal: createFontWeightToken(transformer, 'normal'),
        bold: createFontWeightToken(transformer, 'bold'),
    });
}
function createFontWeightToken(transformer, fontWeight) {
    return {
        get(fontFamily) {
            return transformer.fontWeight(fontWeight, fontFamily);
        },
    };
}
